<div id="srs-finalise-ballot-modal" class="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
  <div id="srs-modal-content" class="relative p-6 bg-white rounded-lg shadow-lg w-[600px] h-[520px]">
    <!-- Close Button -->
    <button id="srs-modal-close-button" class="absolute right-4 top-4" (click)="cancel()">
      <span id="srs-modal-close-icon" class="text-lg material-symbols-rounded text-grey-800">close</span>
    </button>

    <div>
      <!-- Icon and Header -->
      <span id="srs-modal-icon" class="-ml-2 text-6xl material-symbols-rounded" [ngClass]="color">
        {{icon}}
      </span>
      <p id="srs-modal-header" class="mt-2 text-4xl text-left">Finalise Ballot - {{label}}</p>

      <!-- Final Comment -->
      <div id="srs-modal-comment-label" class="relative inline-block text-lg">
        Final Comment
        <span id="srs-modal-comment-required" class="absolute text-sm text-red-500" style="top: 0.1em; margin-left: 0.1em;">*</span>
      </div>
      <textarea
        id="srs-modal-comment-textarea"
        class="w-full p-2 mt-2 border border-gray-300 rounded-lg h-36"
        [(ngModel)]="finalComment">
      </textarea>

      <!-- Checkbox -->
      <div id="srs-modal-checkbox-container" class="flex items-start mt-4">
        <input
          id="srs-modal-checkbox"
          type="checkbox"
          [(ngModel)]="isCheckboxChecked"
          class="mt-1 mr-2"
        />
        <label id="srs-modal-checkbox-label" for="srs-modal-checkbox">
          I have adequately reviewed the ballot results, and the major interest involved with the subject of the standard are affirmative
        </label>
      </div>
    </div>

    <!-- Footer Buttons -->
    <div id="srs-modal-footer" class="flex justify-between mt-6">
      <button
        id="srs-modal-cancel-button"
        (click)="cancel()"
        class="border border-gray-300 rounded-lg px-4 py-2 w-[calc(50%-0.5rem)] mr-2 hover:bg-gray-100">
        Cancel
      </button>
      <button
        id="srs-modal-confirm-button"
        (click)="confirm()"
        [disabled]="!finalComment || !isCheckboxChecked"
        class="btn btn-primary rounded-lg px-4 py-2 w-[calc(50%-0.5rem)] ml-2">
        Finalise
      </button>
    </div>
  </div>
</div>
